"use client";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { FAQSection, Faqs_T } from "@ui/marketing/faq";
import { SectionTemplate } from "components/individuals/blocks";
import { customRichText } from "./individuals/mdx-components";

export interface EnterpriseFAQSectionProps
  extends Omit<Faqs_T, "renderAnswer"> {
  bg: string;
  textColor: string;
  titleColor: string;
}

export const EnterpriseFAQSection = (props: EnterpriseFAQSectionProps) => {
  return (
    <SectionTemplate bg={props.bg}>
      <FAQSection
        renderAnswer={(answer) => (
          <RichText
            content={answer?.raw}
            renderers={customRichText(props.textColor, undefined, undefined, {
              base: 13,
              md: 15,
              lg: 16,
              xl: 17,
            })}
          />
        )}
        {...props}
        from={props.from}
      />
    </SectionTemplate>
  );
};
